export const PAID_PLANS_ENABLED = true;

export const PLAN_ORDER = ["free", "basic", "standard", "premium"];

export const PLAN_COLORS = {
	free: "#a3c4a0",
	basic: "#88c9bf",
	standard: "#b8a8d4",
	premium: "#e0b088",
};

export const PLAN_TAGLINES = {
	free: "Try BodhiStreams free. Explore a curated taste of our collections at no cost.",
	basic:
		"Perfect for casual listeners. Stream from basic collections on two devices, with playlist support.",
	standard:
		"Our most balanced plan. Full collection access, more streaming hours, and great value.",
	premium:
		"For power users and creators. Unlimited streaming, full library, commercial use allowed.",
};

export const COLLECTION_LABEL = {
	free: "Free",
	basic: "Basic",
	standard: "Full",
	premium: "Full",
};

export const planRank = (key) => {
	const i = PLAN_ORDER.indexOf(key);
	return i === -1 ? PLAN_ORDER.length : i;
};

export const enrichPlansWithAvailability = (plans) =>
	plans.map((plan) => ({
		...plan,
		disabled: !PAID_PLANS_ENABLED && plan.key !== "free",
	}));
